import { persistCombineReducers } from 'redux-persist';
import localForage from 'localforage';
import storage from 'root/storage';
import myParkdSettings from 'features/settings/myParkdSettings';
import companyDetails, { CompanyDetailsState } from 'features/company/companyDetails';
import companyVehicles, { CompanyVehiclesState } from 'features/vehicles/companyVehicles';
import companyInvoices from 'features/invoices/companyInvoices';
import userLanguage, { UserLanguageState } from 'root/language/userLanguage';
import modalWindow, { ModalWindowState } from 'root/modal/modalWindow';
import feedback from 'features/support/feedback';
import companyTelematicAccounts, { CompanyTelematicAccountState } from 'features/telematics/companyTelematicAccounts';
import licensePlatesImports from 'features/vehicles/licensePlatesImports';
import globalErrorReducer from 'root/globalErrorReducer';
// Slices
import authSlice, { AuthReducerState, logoutCompleted } from 'features/auth/authSlice';
import userSlice, { UserReducerState } from 'features/user/userSlice';
import companyUsersSlice, { CompanyUsersState } from 'features/users/companyUsersSlice';
import registrationSlice, { RegistrationV2State } from 'features/registration-v2/registrationV2Slice';
import parkdCardsSlice, { ParkdCardsState } from 'features/parkdcards/parkdCardsSlice';
import activeSessionsSlice, { ActiveSessionsState } from 'features/parkingsessions/activeSessionsSlice';
import historicalSessionsSlice, { HistoricalSessionsState } from 'features/parkingsessions/historicalSessionsSlice';
import offstreetSessionsSlice, { OffstreetSessionsState } from 'features/parkingsessions/offstreetSessionsSlice';


type ReduxState = {
    // typed
    auth: AuthReducerState,
    user: UserReducerState,
    companyVehicles: CompanyVehiclesState,
    companyUsers: CompanyUsersState,
    companyDetails: CompanyDetailsState,
    companyTelematicAccounts: CompanyTelematicAccountState,
    modalWindow: ModalWindowState,
    userLanguage: UserLanguageState,
    registration: RegistrationV2State,
    parkdCards: ParkdCardsState,
    historicalSessions: HistoricalSessionsState,
    activeSessions: ActiveSessionsState,
    offstreetSessions: OffstreetSessionsState

    // untyped (todo)
    storage: any,
    myParkdSettings: any,
    companyInvoices: any,
    licensePlatesImports: any,
    feedback: any,
    globalErrorReducer: any,
}


const persistConfig = {
    key: 'myparkd',
    storage: localForage,
};

const appReducer = persistCombineReducers(persistConfig, {
    // slices
    auth: authSlice,
    user: userSlice,
    companyUsers: companyUsersSlice,
    registration: registrationSlice,
    parkdCards: parkdCardsSlice,
    activeSessions: activeSessionsSlice,
    historicalSessions: historicalSessionsSlice,
    offstreetSessions: offstreetSessionsSlice,

    // classic redux (todo)
    storage,
    myParkdSettings,
    userLanguage,
    modalWindow,
    companyDetails,
    companyVehicles,
    companyInvoices,
    companyTelematicAccounts,
    licensePlatesImports,
    feedback,
    globalErrorReducer,
});

const rootReducer = (state: ReduxState, action: any) => {
    if (action.type === logoutCompleted.type) {
        state = {
            myParkdSettings: state.myParkdSettings,
            companyDetails: state.companyDetails,
            storage: { storageLoaded: true },
        };
        persistConfig.storage.removeItem('persist:myparkd');
    }
    return appReducer(state, action);
};

export default rootReducer;
